import { secureLocalStorageGet } from '../../app/helpers'

export interface Company {
  certIdentifier: string
  customerNo: string
  name: string
  organizationCode: string
  personalCode: string
}

function userGWFragments() {
  const currentCompany: Company = secureLocalStorageGet('currentCompany') || {}

  return {
    customerNo: currentCompany.customerNo,
    language: localStorage.getItem('i18nextLng')?.toUpperCase(),
  }
}

export default userGWFragments
